import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { storage, authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import moment from 'moment';
import { 
  ASSESSMENT_LIST,
  ASSESSMENT_ADD,
  ASSESSMENT_DETAIL,
  ASSESSMENT_UPDATE,
  ASSESSMENT_UPLOAD_SET,
  ASSESSMENT_SEARCH_ASSESSMENT_TYPE,
  ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY
} from '../../actions';
import {
  AssessmentListSuccess,
  AssessmentListError,
  AssessmentAddSuccess,
  AssessmentAddError,
  AssessmentDetailSuccess,
  AssessmentDetailError,
  AssessmentUpdateSuccess,
  AssessmentUpdateError,
  AssessmentUploadSetSuccess,
  AssessmentUploadSetError,
  AssessmentSearchAssessmentTypeSuccess,
  AssessmentSearchAssessmentTypeError,
  AssessmentSearchAssessmentCategorySuccess,
  AssessmentSearchAssessmentCategoryError
} from '../../actions';
 
export function* watchAssessmentList() {
  yield takeEvery(ASSESSMENT_LIST, onAssessmentList);
}

export function* watchAssessmentAdd() {
  yield takeEvery(ASSESSMENT_ADD, onAssessmentAdd);
}

export function* watchAssessmentDetail() {
  yield takeEvery(ASSESSMENT_DETAIL, onAssessmentDetail);
}

export function* watchAssessmentUpdate() {
  yield takeEvery(ASSESSMENT_UPDATE, onAssessmentUpdate);
}

export function* watchAssessmentUpload() {
  yield takeEvery(ASSESSMENT_UPLOAD_SET, onAssessmentUpload);
}

export function* watchAssessmentSearchAssessmentType() {
  yield takeEvery(ASSESSMENT_SEARCH_ASSESSMENT_TYPE, onAssessmentSearchAssessmentType);
}

export function* watchAssessmentSearchAssessmentCategory() {
  yield takeEvery(ASSESSMENT_SEARCH_ASSESSMENT_CATEGORY, onAssessmentSearchAssessmentCategory);
}

const onAssessmentListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onAssessmentAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onAssessmentDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onAssessmentUploadAsync = async (file) => {
  var user = await authFB.currentUser;
  var storageRef = storage.ref()
  let now = moment();
  let filename = `${now.format("x")}.${file.name.substr(file.name.lastIndexOf('.') + 1)}`;
  return await new Promise((success, reject) => {
    var uploadTask = storageRef.child(storagePath+'/assessment/' + filename).put(file);
    uploadTask.on('state_changed',
    function(snapshot) {
      var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      console.log('Upload is ' + progress + '% done');
    }, 
    function(error) {
      reject({ name: filename, original: file.name, message: error.code, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid+'/consult_documents/' })
    }, 
    function() {
      uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) { 
          success({ message: 'success', name: filename, original: file.name, url: downloadURL, type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path: user.uid +'/consult_documents/'});
      });
    });
  });
};

const onAssessmentSearchAssessmentTypeAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment_type', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onAssessmentSearchAssessmentCategoryAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/assessment/assessment_category', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* onAssessmentList(data) {
  try {
    const response = yield call(onAssessmentListAsync, data.payload);
    yield put(AssessmentListSuccess(response.data));
  } catch (error) {
    yield put(AssessmentListError(error));
  }
}

function* onAssessmentAdd(data) {
  try {
      const response = yield call(onAssessmentAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentAddSuccess(response.data));
  } catch (error) {
      yield put(AssessmentAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onAssessmentDetail(data) {
  try {
    const response = yield call(onAssessmentDetailAsync, data.payload);
    yield put(AssessmentDetailSuccess(response.data.data));
  } catch (error) {
    yield put(AssessmentDetailError(error));
  }
}

function* onAssessmentUpdate(data) {
  try {
      const response = yield call(onAssessmentUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(AssessmentUpdateSuccess(response.data));
  } catch (error) {
      yield put(AssessmentUpdateError(error));
  }
}

function* onAssessmentUpload({ payload }) {
  const { file } = payload;
  try {
    const response = yield call(onAssessmentUploadAsync, file);
    if(response.message ==='success'){
      yield put(AssessmentUploadSetSuccess(response));
    }
    else{
      yield put(AssessmentUploadSetError(response));
    }
  } catch (error) {
    yield put(AssessmentUploadSetError({ name: '', original: file.name, message: error, url: '',  type: file.type, size: file.size, extension: file.name.substr(file.name.lastIndexOf('.') + 1), path:''}))
  }
}

function* onAssessmentSearchAssessmentType(data) {
  try {
    const response = yield call(onAssessmentSearchAssessmentTypeAsync, data.payload);
    yield put(AssessmentSearchAssessmentTypeSuccess(response.data));
  } catch (error) {
    yield put(AssessmentSearchAssessmentTypeError(error));
  }
}

function* onAssessmentSearchAssessmentCategory(data) {
  try {
    const response = yield call(onAssessmentSearchAssessmentCategoryAsync, data.payload);
    yield put(AssessmentSearchAssessmentCategorySuccess(response.data));
  } catch (error) {
    yield put(AssessmentSearchAssessmentCategoryError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchAssessmentList),
    fork(watchAssessmentAdd),
    fork(watchAssessmentDetail),
    fork(watchAssessmentUpdate),
    fork(watchAssessmentUpload),
    fork(watchAssessmentSearchAssessmentType),
    fork(watchAssessmentSearchAssessmentCategory),
  ]);
} 